import React, { useState, useEffect } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import { Checkbox } from "components/Checkbox";

import "./brandFilter.scss";

export const BrandFilter = ({ result = [], analogs = [], selectedBrands: externalSelectedBrands, onBrandsChange }) => {
  // Получаем уникальные бренды из result и analogs, сортируем от А до Я (A-Z)
  const allResults = [...result, ...analogs];
  const uniqueBrands = [...new Set(allResults.map(item => item.brand).filter(Boolean))]
    .sort((a, b) => a.localeCompare(b, 'ru', { sensitivity: 'base' }));

  // Подсчитываем количество товаров для каждого бренда
  const getBrandCount = (brandName) => {
    return allResults.filter(item => item.brand === brandName).length;
  };

  const [selectedBrands, setSelectedBrands] = useState(
    externalSelectedBrands || new Set(uniqueBrands)
  );
  const [selectAll, setSelectAll] = useState(
    externalSelectedBrands ? externalSelectedBrands.size === uniqueBrands.length : true
  );

  useEffect(() => {
    if (uniqueBrands.length > 0) {
      if (externalSelectedBrands && externalSelectedBrands.size > 0) {
        // Проверяем, что все текущие бренды выбраны
        const allBrandsSelected = uniqueBrands.every(brand => externalSelectedBrands.has(brand));
        if (allBrandsSelected && externalSelectedBrands.size === uniqueBrands.length) {
          setSelectedBrands(externalSelectedBrands);
          setSelectAll(true);
        } else {
          // Если не все бренды выбраны, выбираем все
          const allBrandsSet = new Set(uniqueBrands);
          setSelectedBrands(allBrandsSet);
          setSelectAll(true);
          if (onBrandsChange) {
            onBrandsChange(allBrandsSet);
          }
        }
      } else {
        // По умолчанию выбираем все бренды
        const allBrandsSet = new Set(uniqueBrands);
        setSelectedBrands(allBrandsSet);
        setSelectAll(true);
        if (onBrandsChange) {
          onBrandsChange(allBrandsSet);
        }
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniqueBrands.join(',')]);

  const handleSelectAll = (checked) => {
    const newSelected = checked ? new Set(uniqueBrands) : new Set();
    setSelectedBrands(newSelected);
    setSelectAll(checked);
    if (onBrandsChange) {
      onBrandsChange(newSelected);
    }
  };

  const handleBrandToggle = (brandName, checked) => {
    const newSelected = new Set(selectedBrands);
    if (checked) {
      newSelected.add(brandName);
    } else {
      newSelected.delete(brandName);
    }
    setSelectedBrands(newSelected);
    setSelectAll(newSelected.size === uniqueBrands.length);
    if (onBrandsChange) {
      onBrandsChange(newSelected);
    }
  };

  if (uniqueBrands.length === 0) {
    return null;
  }

  return (
    <UncontrolledDropdown className="brand-filter-dropdown">
      <DropdownToggle className="btn btn-secondary">
        Фильтр по брендам
      </DropdownToggle>
      <DropdownMenu>
        <div className="px-3 py-2">
          <Checkbox
            id="select-all-brands"
            checked={selectAll}
            onChange={(e) => handleSelectAll(e.target.checked)}
          >
            Выбрать все
          </Checkbox>
        </div>
        {uniqueBrands.map((brandName) => {
          const count = getBrandCount(brandName);
          return (
            <div key={brandName} className="px-3 py-2">
              <Checkbox
                id={`brand-${brandName}`}
                checked={selectedBrands.has(brandName)}
                onChange={(e) => handleBrandToggle(brandName, e.target.checked)}
              >
                {brandName}
                <span className="ml-2" style={{ opacity: 0.5 }}>{count}</span>
              </Checkbox>
            </div>
          );
        })}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};
